import { APIClient } from "./api_helper";

const api = new APIClient();

/**
 * Pobierz dane aktualnie zalogowanego użytkownika
 */
export const getCurrentUser = (userId) => {
  return api.get("/users/" + userId);
};

/**
 * Aktualizuj profil użytkownika
 * @param {string} userId - ID użytkownika
 * @param {Object} data - Dane do aktualizacji
 */
export const updateCurrentUser = (userId, data) => {
  return api.update(`/users/${userId}`, data);
};

/**
 * Zmień hasło użytkownika
 * @param {string} userId - ID użytkownika
 * @param {Object} passwordData - Dane hasła (oldPassword, newPassword)
 */
export const changeUserPassword = (userId, passwordData) => {
  return api.update(`/profile/${userId}/password`, {
    newPassword: passwordData.newPassword,
    oldPassword: passwordData.oldPassword,
  });
};
